import React from "react";
import PropTypes from "prop-types";

import ExportButton from "../ExportButton";

function callEvent(name) {
  const evt = document.createEvent("Event");
  evt.initEvent(name, true, false);
  window.dispatchEvent(evt);
}

const Add = ({
  accountIsSai
}) => (
  <span className="dropdown">
    <button
      type="button"
      className="btn btn-pink btn-raised btn-long dropdown-toggle margin-right-five hidden-xs hidden-sm"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      ADD
      <span className="caret" />
    </button>

    <ul className="dropdown-menu" aria-labelledby="add">
      {accountIsSai == true &&
        <li>
          <a
            href="javascript:void(0);"
            onClick={() => {
              callEvent("openModalToAddSaiCertificate");
            }}
          >
            ADD SAI CERTIFICATION
          </a>
        </li>
      }
      <li>
        <a
          href="javascript:void(0);"
          onClick={() => {
            callEvent("openModalToAddCertificate");
          }}
        >
          ADD CERTIFICATION
        </a>
      </li>
      <li>
        <a
          href="javascript:void(0);"
          onClick={() => {
            callEvent("openModalToAddCertificateType");
          }}
        >
          ADD CERTIFICATION TYPE
        </a>
      </li>
      <li>
        <a href="/add_multiple_certifications">IMPORT CERTIFICATIONS</a>
      </li>
    </ul>
  </span>
);

const Analytics = () => (
  <a
    href="/certifications_analytics"
    className="btn btn-indigo btn-raised btn-long margin-right-five hidden-xs hidden-sm"
  >
    ANALYTICS
  </a>
);

const Options = ({
  locationId,
  active
}) => (
  <span className="dropdown">
    <button
      type="button"
      className="btn btn-grey btn-raised btn-long dropdown-toggle hidden-xs hidden-sm"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      OPTIONS
      <span className="caret" />
    </button>

    <ul className="dropdown-menu" aria-labelledby="options">
      <li>
        <ExportButton
          url={
            "/export/certifications?location_id=" +
            locationId +
            "&active=" +
            active
          }
        />
      </li>
    </ul>
  </span>
);

const Actions = ({
  locationId,
  active,
  accountIsSai
}) => (
  <div className="pull-right">
    <Add
      accountIsSai={accountIsSai}
    />

    <Analytics />

    <Options
      locationId={locationId}
      active={active}
    />
  </div>
);

Actions.propTypes = {
  locationId: PropTypes.string,
  active: PropTypes.number,
  accountIsSai: PropTypes.bool
};

export default Actions;
